






import { Component, Mixins } from "vue-property-decorator";
import OptionRadioSelector from "../../../../../system/selectors/OptionRadioSelector.vue";
import { ModelEditableMixin } from "../../../../../system/mixins";
import { StandardOption } from "../../../../../system/selectors/mixins";

@Component({
  components: {
    selector: OptionRadioSelector,
  }
})
export default class ClaioImagePreviewSizeSelector extends Mixins(ModelEditableMixin) {
  static OptionSets: StandardOption<boolean>[] = [
    new StandardOption<boolean>("全体表示", true, "画像の全体が枠に収まるように表示します"),
    new StandardOption<boolean>("等倍表示", false, "画像と同じサイズで表示します"),
  ];

  get options(): StandardOption<boolean>[] {
    return ClaioImagePreviewSizeSelector.OptionSets;
  }
}
